import React, { useEffect, useState } from 'react';

/**
 * RouteSplash — Suspense fallback for heavy lazy-loaded pages.
 *
 * Tiny pulsing-S overlay. Only renders after a 250ms delay so fast chunk
 * fetches don't flash a splash. Used as <Suspense fallback={<RouteSplash />}>.
 */
export default function RouteSplash({ delay = 250 }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), delay);
    return () => clearTimeout(t);
  }, [delay]);

  if (!show) return null;

  return (
    <div
      data-testid="route-splash"
      aria-busy="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9998,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(250, 250, 250, 0.78)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        animation: 'simplly-route-fade 200ms ease both',
      }}
    >
      <img
        src="/simplly_favicon.png"
        alt=""
        style={{
          width: 56,
          height: 56,
          objectFit: 'contain',
          filter: 'drop-shadow(0 6px 18px rgba(0,163,161,0.35))',
          animation: 'simplly-route-pulse 1.1s ease-in-out infinite',
        }}
      />
      <style>{`
        @keyframes simplly-route-pulse {
          0%, 100% { transform: scale(1);    opacity: 1; }
          50%      { transform: scale(0.86); opacity: 0.55; }
        }
        @keyframes simplly-route-fade {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
      `}</style>
    </div>
  );
}
